export default __webpack_public_path__ + "static/couplethrapy-5669fdb0057f702852ac805c98ee4ed2.webp";